// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__7JSG3"};